import { render, staticRenderFns } from "./request-demo.vue?vue&type=template&id=1d54e670&scoped=true&"
import script from "./request-demo.vue?vue&type=script&lang=js&"
export * from "./request-demo.vue?vue&type=script&lang=js&"
import style0 from "./request-demo.vue?vue&type=style&index=0&id=1d54e670&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d54e670",
  null
  
)

export default component.exports